/* global axios */

const CLAUDIA_BASE_URL = window.globalConfig?.CLAUDIA_URL || 'http://localhost:8082/api';

class ClaudiaAPI {
  getAuthHeaders(store) {
    const currentUser = store?.getters?.getCurrentUser || {};
    const cognitoAccessToken = currentUser.cognito_access_token || null;
    
    if (!cognitoAccessToken) {
      console.warn('Claudia API: No Cognito access token available');
      return {};
    }
    
    return {
      Authorization: `Bearer ${cognitoAccessToken}`,
    };
  }

  async getConversationEvents(conversationId, store) {
    const response = await axios.get(
      `${CLAUDIA_BASE_URL}/conversations/${conversationId}/events`,
      { headers: this.getAuthHeaders(store) }
    );
    return response.data;
  }

  // Groups of bubbles split from the same ClaudIA response. Each group exposes the anchor
  // (the bubble that carries the audit) and whether audit data exists. Used to show the audit
  // trigger only on the anchor and to connect the continuation bubbles.
  async getConversationMessageGroups(conversationId, store) {
    const response = await axios.get(
      `${CLAUDIA_BASE_URL}/conversations/${conversationId}/message-groups`,
      { headers: this.getAuthHeaders(store) }
    );
    return response.data;
  }

  // Knowledge bases linked to an account, scoped by CloudChat instance
  // (`GET /knowledge-base?accountId=&instance=`). Used to resolve which KB(s)
  // to query for the Improvement Center pending-review count, since the
  // sidebar renders before any KB is selected in the claudia-app microfrontend.
  async listKnowledgeBases(accountId, instance, store) {
    const response = await axios.get(`${CLAUDIA_BASE_URL}/knowledge-base`, {
      params: { accountId, instance },
      headers: this.getAuthHeaders(store),
    });
    return response.data;
  }

  async getImprovementCenterPending(accountId, instance, store) {
    const response = await axios.get(
      `${CLAUDIA_BASE_URL}/improvement-center/account/${accountId}/pending`,
      { params: { instance }, headers: this.getAuthHeaders(store) }
    );
    return response.data;
  }

  // V0.1 (Lacunas) pending-review count for a knowledge base.
  async getImprovementsSummary(knowledgeBaseId, store) {
    const response = await axios.get(
      `${CLAUDIA_BASE_URL}/knowledge-base/${knowledgeBaseId}/improvements/summary`,
      { headers: this.getAuthHeaders(store) }
    );
    return response.data;
  }

  // V0.2 (Qualidade) pending-review count for a knowledge base.
  async getQualitySummary(knowledgeBaseId, store) {
    const response = await axios.get(
      `${CLAUDIA_BASE_URL}/knowledge-base/${knowledgeBaseId}/improvements/quality/summary`,
      { headers: this.getAuthHeaders(store) }
    );
    return response.data;
  }

  async transcribeAudio(audioUrl, store) {
    if (!audioUrl) {
      throw new Error('Audio URL is required');
    }

    if (!store) {
      throw new Error('Vuex store is required for authentication');
    }

    try {
      const response = await axios.post(
        `${CLAUDIA_BASE_URL}/transcription/audio`,
        { audioUrl },
        { headers: this.getAuthHeaders(store) }
      );

      return response.data;
    } catch (error) {
      console.error('Claudia API: Transcription failed', error);
      throw error;
    }
  }
}

export default new ClaudiaAPI();
